import List from "@/components/list";
import router from "@/router";
// import vue from "@/main";

const Table = args => {

  // 查看调查人员
  function enrollUserList(enroll) {
    router.push({
      path: "enrollaudit/rotateUsers",
      query: {
        id: enroll.classParentId,
        className: enroll.classParentName,
      }
    });
  }

  const Deal = ({ props: { vo } }) => {
    const enroll = vo.row;

    return (
      <div class="deal-group">
        <el-tooltip
          content="报名审核"
          placement="top"
          v-permission="rotationAudit:enroll:page"
        >
          <i
            class="user-enroll-icon"
            onClick={() => enrollUserList(enroll)}
          ></i>
        </el-tooltip>
      </div>
    );
  };

  const ClassStatusName = ({ props: { vo } }) => {
    const classStatusName = vo.row.classStatusName
    return <div domPropsInnerHTML={classStatusName}></div>;
  };
  const EnrollTime = ({ props: { vo } }) => {
    const enrollTime = vo.row.enrollTime
    return <div domPropsInnerHTML={enrollTime}></div>;
  };
  const EnrollSituation = ({ props: { vo } }) => {
    const enrollSituation = vo.row.enrollSituation
    return <div domPropsInnerHTML={enrollSituation}></div>;
  };
  const PlanStuNum = ({ props: { vo } }) => {
    const planStuNum = vo.row.planStuNum
    return <div domPropsInnerHTML={planStuNum}></div>;
  };
  const AccountTableConfig = [
    {
      label: "班级名称",
      minWidth: "200",
      render: (vo) => (
        <div class="base-hover-char"
          onClick={() => {
            let query = { id: "0" };
            if (vo.row.classParentId) {
              query.parentId = vo.row.classParentId;
            }
            router.push({
              path: "offlineClass/detail",
              query: query,
            });
          }}
        >
          {vo.row.classParentName}
        </div>
      ),
    },
    {
      label: "主办单位",
      prop: "organizer",
      minWidth: "150",
      showOverflowTooltip: true
    },
    // {
    //   label: "办班级别",
    //   prop: "classLevelName",
    //   width: "100",
    //   showOverflowTooltip: true
    // },
    {
      label: "班级状态",
      prop: "classStatusName",
      minWidth: "120",
      render: vo => <ClassStatusName vo={vo} />
    },
    {
      label: "报名情况",
      prop: "enrollSituation",
      minWidth: "120",
      render: vo => <EnrollSituation vo={vo} />,
      renderHeader: () => {
        return (
          <div class="table-row-column">
            <span>报名情况</span>
            <span>报名|计划(人)</span>
          </div>
        )
      },
    },
    {
      label: "报名时间",
      prop: "enrollTime",
      width: "220",
      render: vo => <EnrollTime vo={vo} />
    },
    {
      label: "操作",
      fixed: "right",
      width: "80",
      align: "center",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <List
      {...args}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
